export enum IconType {
  'calculate-route' = 'calculate-route',
  'round-trip' = 'round-trip',
  'arrow-right' = 'arrow-right',
  'arrow-left' = 'arrow-left',
  'arrow-up' = 'arrow-up',
  'briefcase' = 'briefcase',
  'briefcase-outline' = 'briefcase-outline',
  'car' = 'car',
  'car-outline' = 'car-outline',
  'cards' = 'cards',
  'cards-outline' = 'cards-outline',
  'calendar' = 'calendar',
  'calendar-outline' = 'calendar-outline',
  'categories' = 'categories',
  'categories-outline' = 'categories-outline',
  'clipboard' = 'clipboard',
  'clipboard-outline' = 'clipboard-outline',
  'close' = 'close',
  'close-circle' = 'close-circle',
  'close-circle-outline' = 'close-circle-outline',
  'coins' = 'coins',
  'check' = 'check',
  'check-circle' = 'check-circle',
  'check-circle-outline' = 'check-circle-outline',
  'deactivated' = 'deactivated',
  'down' = 'down',
  'download' = 'download',
  'download-excel' = 'download-excel',
  'download-excel-outline' = 'download-excel-outline',
  'download-pdf' = 'download-pdf',
  'download-pdf-outline' = 'download-pdf-outline',
  'dollar-sign' = 'dollar-sign',
  'double-arrow-left' = 'double-arrow-left',
  'double-arrow-right' = 'double-arrow-right',
  'edit' = 'edit',
  'edit-circle' = 'edit-circle',
  'expense' = 'expense',
  'exclamation-mark' = 'exclamation-mark',
  'expand' = 'expand',
  'eye-closed' = 'eye-closed',
  'eye-open' = 'eye-open',
  'favorite-place' = 'favorite-place',
  'favorite-place-outline' = 'favorite-place-outline',
  'flag' = 'flag',
  'flag-outline' = 'flag-outline',
  'filter' = 'filter',
  'filter-outline' = 'filter-outline',
  'gear' = 'gear',
  'gear-outline' = 'gear-outline',
  'gps-outline' = 'gps-outline',
  'grip' = 'grip',
  'help' = 'help',
  'help-outline' = 'help-outline',
  'home' = 'home',
  'home-outline' = 'home-outline',
  'integrations' = 'integrations',
  'integrations-outline' = 'integrations-outline',
  'key' = 'key',
  'key-outline' = 'key-outline',
  'left' = 'left',
  'light-bulb' = 'light-bulb',
  'link' = 'link',
  'lock' = 'lock',
  'lock-outline' = 'lock-outline',
  'loading' = 'loading',
  'pin-and-pen-outline' = 'pin-and-pen-outline',
  'pin-and-pen' = 'pin-and-pen',
  'play' = 'play',
  'logout-outline' = 'logout-outline',
  'map' = 'map',
  'map-outline' = 'map-outline',
  'marker' = 'marker',
  'marker-outline' = 'marker-outline',
  'minus' = 'minus',
  'more-horizontal' = 'more-horizontal',
  'more-vertical' = 'more-vertical',
  'note' = 'note',
  'note-outline' = 'note-outline',
  'person' = 'person',
  'person-circle' = 'person-circle',
  'person-circle-outline' = 'person-circle-outline',
  'person-outline' = 'person-outline',
  'premium' = 'premium',
  'reimbursement' = 'reimbursement',
  'reimbursement-outline' = 'reimbursement-outline',
  'report' = 'report',
  'report-outline' = 'report-outline',
  'right' = 'right',
  'rules' = 'rules',
  'rules-outline' = 'rules-outline',
  'schedule' = 'schedule',
  'schedule-outline' = 'schedule-outline',
  'search' = 'search',
  'search-empty' = 'search-empty',
  'share' = 'share',
  'sheets-outline' = 'sheets-outline',
  'shop' = 'shop',
  'shop-outline' = 'shop-outline',
  'sort' = 'sort',
  'summary' = 'summary',
  'summary-outline' = 'summary-outline',
  'star' = 'star',
  'steering-wheel' = 'steering-wheel',
  'star-outline' = 'star-outline',
  'synced' = 'synced',
  'tag' = 'tag',
  'tag-outline' = 'tag-outline',
  'tax' = 'tax',
  'tax-outline' = 'tax-outline',
  'trash' = 'trash',
  'trash-outline ' = 'trash-outline',
  'team' = 'team',
  'team-outline' = 'team-outline',
  'tracker' = 'tracker',
  'tracker-outline' = 'tracker-outline',
  'transaction' = 'transaction',
  'transaction-outline' = 'transaction-outline',
  'trip' = 'trip',
  'trip-outline' = 'trip-outline',
  'question' = 'question',
  'up' = 'up',
  'upload' = 'upload',
  'upload-csv' = 'upload-csv',
  'upload-csv-outline' = 'upload-csv-outline',
  'upload-outline' = 'upload-outline',
  'vehicle' = 'vehicle',
  'vehicle-outline' = 'vehicle-outline',
  'work' = 'work',
  'work-outline' = 'work-outline',
  'wallet' = 'wallet',
  'wallet-outline' = 'wallet-outline',
  'wallet-with-bill' = 'wallet-with-bill',
  'wallet-with-bill-outline' = 'wallet-with-bill-outline',
  'heart' = 'heart',
  'photo' = 'photo',
  'photo-outline' = 'photo-outline',
  'clock' = 'clock',
  'clock-outline' = 'clock-outline',
  'plus' = 'plus',
  'info' = 'info',
  'open' = 'open',
  'person-check-outline' = 'person-check-outline'
}

export enum FeatureIconType {
  'beach-chair' = 'beach-chair',
  'car-in-motion' = 'car-in-motion',
  'everlance' = 'everlance',
  'everlance-logo' = 'everlance-logo',
  'expenses' = 'expenses',
  'money-in-wallet' = 'money-in-wallet',
  'pay-report' = 'pay-report',
  'tags' = 'tags',
  'work-hours' = 'work-hours',
  'data-exports' = 'data-exports',
  'wallet-send-payments' = 'wallet-send-payments',
  'rules' = 'rules',
  'flags' = 'flags',
  'wallet' = 'wallet',
  'calendar' = 'calendar',
  'flags-banner' = 'flags-banner',
  'insurance' = 'insurance',
  'categories' = 'categories',
  'driver-checkup' = 'driver-checkup',
  'sedan-driving' = 'sedan-driving',
  'product' = 'product',
  'time' = 'time',
  'trips' = 'trips',
  'transactions' = 'transactions',
  'share' = 'share',
  'reports' = 'reports',
  'premium' = 'premium',
  'location' = 'location',
  'data-export' = 'data-export',
  'credit-cards' = 'credit-cards',
  'expense-sync' = 'expense-sync',
  'confetti' = 'confetti',
  'clapping' = 'clapping',
  'visibility' = 'visibility'
}

export enum ImgIconType {
  'Wagon' = 'Pioneer+Wagon+Filled-100.png',
  'Rocket' = 'Launched+Rocket+Filled-100.png',
  'PropPlane' = 'Prop+Plane+Filled-100.png',
  'GoKart' = 'Go+Kart+Filled-100.png',
  'RaceCar' = 'F1+Race+Car+Side+View+Filled-100.png',
  'Convertible' = 'Convertible+Filled-100.png',
  'Pickup' = 'Pickup+filled+100-1.png',
  'Truck' = 'Truck+filled+100.png',
  'Sedan' = 'Sedan+Filled-100-2.png'
}
